import { render, staticRenderFns } from "./yidafu.vue?vue&type=template&id=57d8a95e&scoped=true&"
import script from "./yidafu.vue?vue&type=script&lang=js&"
export * from "./yidafu.vue?vue&type=script&lang=js&"
import style0 from "./yidafu.vue?vue&type=style&index=0&id=57d8a95e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57d8a95e",
  null
  
)

export default component.exports